export const printMonthlyReport = ({
  activeTab,
  monthLabel,
  generatedTime,
  monthEndData,
  invoiceGroups,
  assetData,
  printedBy = "Accounts",
}) => {
  const existingIframe = document.getElementById("report-print-iframe");
  if (existingIframe) existingIframe.remove();

  const iframe = document.createElement("iframe");
  iframe.id = "report-print-iframe";
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;

  let reportHtml = "";

  // ১) Month End Refer Print Table
  if (activeTab === "month-end") {
    const rowsHtml = (monthEndData.rows || [])
      .map(
        (row) => `
        <tr>
          <td style="font-weight: bold;">${row.chartAccId}</td>
          <td style="text-transform: uppercase; font-weight: 600;">${row.agentName}</td>
          <td style="text-align: center;">${row.mobile || "---"}</td>
          <td style="text-align: center; font-weight: 600;">${row.billsCount}</td>
          <td style="text-align: right; font-weight: bold;">৳ ${row.netCommission.toFixed(2)}</td>
          <td style="text-align: right; font-weight: bold;">৳ ${row.paidAmount.toFixed(2)}</td>
          <td style="text-align: right; font-weight: bold;">৳ ${row.dueAmount.toFixed(2)}</td>
        </tr>
      `
      )
      .join("");

    reportHtml = `
      <div style="font-size: 13px; font-weight: bold; margin-bottom: 8px;">Agent / Refer Wise Overview</div>
      <table class="report-table">
        <thead>
          <tr>
            <th style="text-align: left; width: 14%;">CHART ACC ID</th>
            <th style="text-align: left; width: 34%;">AGENT / REFER</th>
            <th style="text-align: center; width: 10%;">MOBILE</th>
            <th style="text-align: center; width: 8%;">BILLS</th>
            <th style="text-align: right; width: 14%;">NET COMMISSION</th>
            <th style="text-align: right; width: 10%;">PAID</th>
            <th style="text-align: right; width: 10%;">DUE</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml || '<tr><td colspan="7" style="text-align: center; padding: 15px;">No records found.</td></tr>'}
        </tbody>
        <tfoot>
          <tr style="font-weight: bold; background: #fafafa;">
            <td colspan="3">Grand Total (${monthEndData.grandTotal?.totalAgents || 0} agents)</td>
            <td style="text-align: center;">${monthEndData.grandTotal?.totalBills || 0}</td>
            <td style="text-align: right;">৳ ${(monthEndData.grandTotal?.totalNetCommission || 0).toFixed(2)}</td>
            <td style="text-align: right;">৳ ${(monthEndData.grandTotal?.totalPaid || 0).toFixed(2)}</td>
            <td style="text-align: right;">৳ ${(monthEndData.grandTotal?.totalDue || 0).toFixed(2)}</td>
          </tr>
        </tfoot>
      </table>
    `;
  } 
  // ২) Invoice Statement with Refer Status
  else if (activeTab === "invoice-statement") {
    reportHtml = (invoiceGroups || [])
      .map((grp) => {
        const billsHtml = (grp.bills || [])
          .map(
            (b) => `
            <tr>
              <td style="font-weight: bold;">${b.invNo}</td>
              <td>${new Date(b.date).toLocaleDateString("en-GB")}</td>
              <td style="text-transform: uppercase; font-weight: 500;">${b.patient}</td>
              <td style="text-align: right;">৳ ${b.netAmt.toFixed(2)}</td>
              <td style="text-align: right; font-weight: bold;">৳ ${b.netCom.toFixed(2)}</td>
              <td style="text-align: center; font-size: 10px; font-weight: bold;">${b.status}</td>
            </tr>
          `
          )
          .join("");

        return `
          <div class="group-block">
            <div style="font-size: 13px; font-weight: bold; margin-bottom: 4px;">
              (${grp.agentName}) <span style="font-weight: normal; font-size: 11.5px;">(Chart Acc Id: ${grp.chartAccId})</span>
            </div>
            <table class="report-table" style="margin-bottom: 0;">
              <thead>
                <tr>
                  <th style="text-align: left; width: 18%;">INV NO</th>
                  <th style="text-align: left; width: 14%;">DATE</th>
                  <th style="text-align: left; width: 32%;">PATIENT</th>
                  <th style="text-align: right; width: 14%;">NET AMT</th>
                  <th style="text-align: right; width: 12%;">NET COM</th>
                  <th style="text-align: center; width: 10%;">STATUS</th>
                </tr>
              </thead>
              <tbody>
                ${billsHtml}
                <tr style="font-weight: bold; background: #fafafa;">
                  <td colspan="4" style="text-align: left;">Sub-total (Net Commission)</td>
                  <td style="text-align: right;">৳ ${grp.thisPeriodNetCom.toFixed(2)}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <div style="font-size: 11.5px; padding: 6px 8px; border: 1px solid #000; border-top: none; font-weight: 500;">
              Opening ৳ ${grp.opening.toFixed(0)} &nbsp;·&nbsp; This period Net Com ৳ ${grp.thisPeriodNetCom.toFixed(2)} &nbsp;·&nbsp; Paid ৳ ${grp.paid.toFixed(2)} &nbsp;·&nbsp; <strong>Closing ৳ ${grp.closing.toFixed(0)}</strong>
            </div>
          </div>
        `;
      })
      .join("");
  } 
  // ৩) Asset Summary
  else if (activeTab === "asset-summary" && assetData) {
    reportHtml = `
      <div style="font-size: 13px; font-weight: bold; margin-bottom: 8px;">Asset — Daily Receive & Payment</div>
      <table class="report-table">
        <thead>
          <tr>
            <th style="text-align: left; width: 60%;">NARRATION</th>
            <th style="text-align: right; width: 20%;">DEBIT</th>
            <th style="text-align: right; width: 20%;">CREDIT</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="font-weight: 500;">Total Receive</td>
            <td style="text-align: right; font-weight: bold;">৳ ${assetData.totalReceive.toFixed(2)}</td>
            <td style="text-align: right;">—</td>
          </tr>
          <tr>
            <td style="font-weight: 500;">Total Payment (agent payout + others expense)</td>
            <td style="text-align: right;">—</td>
            <td style="text-align: right; font-weight: bold;">৳ ${assetData.totalPayment.toFixed(2)}</td>
          </tr>
          <tr>
            <td style="font-weight: 500;">Opening (all activity before this period)</td>
            <td style="text-align: right;">—</td>
            <td style="text-align: right; font-weight: bold;">৳ ${Math.abs(assetData.openingBalance).toFixed(0)}</td>
          </tr>
          <tr style="font-weight: bold; background: #fafafa;">
            <td>Balance in duration (Receive – Payment)</td>
            <td colspan="2" style="text-align: right;">৳ ${assetData.balanceInDuration.toLocaleString()}</td>
          </tr>
          <tr style="font-weight: bold; background: #f0f0f0;">
            <td>Balance with opening (Opening + Balance in duration)</td>
            <td colspan="2" style="text-align: right; font-size: 13px;">৳ ${assetData.balanceWithOpening.toLocaleString()}</td>
          </tr>
        </tbody>
      </table>
    `;
  }

  doc.open();
  doc.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Monthly Report Print</title>
        <style>
          @page {
            size: A4 portrait;
            margin: 12mm 12mm 14mm 12mm;
          }
          * { box-sizing: border-box; }
          html, body {
            margin: 0;
            padding: 0;
            font-family: Arial, Helvetica, sans-serif;
            color: #000;
            background: #fff;
            font-size: 11.5px;
            line-height: 1.35;
          }
          .watermark {
            position: fixed;
            top: 55%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-30deg);
            font-size: 70px;   
            font-weight: 900;
            white-space: nowrap;
            color: rgba(0, 0, 0, 0.035);
            text-transform: uppercase;
            letter-spacing: 6px;
            white-space: nowrap;
            pointer-events: none;
            z-index: 0;
          }
          .page-container {
            position: relative;
            min-height: 96vh;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
          .main-content {
            flex: 1 0 auto;
            position: relative;
            z-index: 1;
          }
          .header {
            text-align: center;
            margin-bottom: 16px;
          }
          .header h1 {
            font-size: 19px;
            margin: 0;
            font-weight: 900;
            letter-spacing: 0.3px;
          }
          .header p {
            font-size: 11px;
            margin: 3px 0;
            color: #111;
          }
          .header h2 {
            font-size: 13.5px;
            text-decoration: underline;
            margin: 5px 0 3px;
            font-weight: bold;
          }
          .report-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 10px;
          }
          .report-table th, .report-table td {
            border: 1px solid #000;
            padding: 5.5px 7px;
            font-size: 11.5px;
          }
          .report-table th {
            background-color: #fff;
            font-weight: bold;
          }
          .group-block {
            page-break-inside: avoid;
            margin-bottom: 16px;
          }
          .footer-section {
            flex-shrink: 0;
            width: 100%;
            margin-top: 25px;
            position: relative;
            z-index: 1;
          }
          .bottom-bar {
            border-top: 1px solid #000;
            padding-top: 5px;
            display: flex;
            justify-content: space-between;
            font-size: 9.5px;
            color: #111;
          }
        </style>
      </head>
      <body>
        <div class="watermark">Mukti Hospital</div>
        
        <div class="page-container">
          <div class="main-content">
            <div class="header">
              <h1>Mukti Hospital (Pvt.) Ltd.</h1>
              <p>Pathology Department — Comilla</p>
              <h2>${
                activeTab === "month-end"
                  ? "Agent / Refer Wise Overview"
                  : activeTab === "invoice-statement"
                  ? "Agent / Refer Wise Report"
                  : "Asset — Daily Receive & Payment"
              }</h2>
              <p><strong>Period:</strong> ${monthLabel}</p>
              <p style="font-size: 9.5px; color: #444;">Generated: ${generatedTime}</p>
            </div>

            ${reportHtml}
          </div>

          <div class="footer-section">
            <div class="bottom-bar">
              <div>Printed by: ${printedBy}</div>
              <div>Software Powered By: Microters · microters.com</div>
            </div>
          </div>
        </div>
      </body>
    </html>
  `);
  doc.close();

  setTimeout(() => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
  }, 250);
};